module.exports = __webpack_public_path__ + "img/1099651.741e0c65.svg";